// Google Ads conversion tracking utilities

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    gtag: (...args: unknown[]) => void;
  }
}

/**
 * Push an event to the GTM dataLayer
 */
export const pushToDataLayer = (event: string, data?: Record<string, unknown>) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...data,
  });
};

/**
 * Track Google Ads purchase conversion
 */
const trackGoogleAdsPurchase = (transactionId?: string) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-951713638/7f6QCKiY7eAbEOb-58UD',
      transaction_id: transactionId || '',
    });
  }
};

/**
 * Track Google Ads account created conversion
 */
const trackGoogleAdsAccountCreated = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-951713638/JMcoCKX_7eAbEOb-58UD',
      value: 1.0,
      currency: 'GBP',
    });
  }
};

/**
 * Track when a user creates an account (Google Ads conversion)
 */
export const trackAccountCreated = (email?: string) => {
  // Google Ads conversion
  trackGoogleAdsAccountCreated();

  // Also push to dataLayer for GTM
  pushToDataLayer('account_created', {
    user_email: email,
  });
};

/**
 * Track when a user reaches the dashboard with queries/websites
 */
export const trackDashboardReached = (websiteCount: number) => {
  pushToDataLayer('dashboard_reached', {
    website_count: websiteCount,
  });
};

/**
 * Track when a user completes a purchase (Google Ads conversion)
 */
export const trackPurchase = (transactionId?: string, value?: number, currency = 'USD') => {
  // Google Ads conversion
  trackGoogleAdsPurchase(transactionId);

  // Also push to dataLayer for GTM
  pushToDataLayer('purchase', {
    transaction_id: transactionId,
    value,
    currency,
  });
};
